<template>
  <div class="import-list">

    <div class="list">
      <NonScImportItem
        v-for="
          (item, i) in items
        "
        :key="i"
        :item="item"
        @copy="
          () => copy(item.id)
        "
        @update="
          () => edit(item.id)
        "
      />
    </div>

    <div class="pager">
      <el-pagination
        :background="true"
        :layout="
          'prev, pager, next'
        "
        @current-change="
          (page) => paging.open = page
        "
        :pager-count="
          paging.count
        "
        :current-page="
          paging.open
        "
        :page-size="
          paging.limit
        "
        :total="total"
      />
      
      <NonScImportEditor
        :title="
          'แก้ไขข้อมูล'
        "
        :open="
          editor.open
        "
        :form="
          editor.input
        "
        @submit="
          value => update(value)
        "
        @remove="
          id => remove(id)
        "
        @closed="
          () => editor.open = false
        "
      />
    </div>
  </div>
</template>

<script lang="js">

// Components
import NonScAlert from '../../components/NonScAlert.vue'
import NonScImportEditor from './NonScImportEditor.vue'
import NonScImportItem from './NonScImportItem.vue'

export default {
  components: {
    NonScAlert,
    NonScImportEditor,
    NonScImportItem,
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      record: [],
      editor: {
        open  : false,
        input : null,
      },
      paging: {
        open  : 1,
        count : 5,
        limit : 10
      }
    }
  },
  watch: {
    list: {
      handler(value) {
        this.record = value
      },
      deep: true,
    },
    'editor.input'(value) {
      if (value) this.editor.open = true
    },
    'editor.open'(open) {
      if (!open) this.editor.input = null
    },
    page(value) {
      this.paging.open = value
    },
    'paging.open'(value) {
      this.$emit('page-change', value)
    }
  },
  computed: {
    items() {
      return this.record.slice(
        this.start, this.stop
      )
    },
    total() {
      return (
        Array.isArray(this.list) ? this.list.length : 0
      )
    },
    current() {

      // Paging Props
      const { limit, open } = this.paging

      // Paging Max Page
      const max = (
        Math.ceil(this.total / limit) || 1
      )

      return (
        open > max ? max : open
      )
    },
    limit() {
      return this.paging.limit
    },
    start() {
      return (
        (this.current * this.limit) - this.limit
      )
    },
    stop() {
      return (
        this.start + this.limit
      )
    },
  },
  mounted() {

    //
    this.record = this.list
    
    //
    this.paging.open = this.page
  },
  methods: {
    exist(id) {
      return this.record.some(
        e => e.id == id
      )
    },
    get(id) {
      return this.record.find(
        e => e.id == id
      )
    },
    copy(id) {
      if (this.exist(id)) {
        this.$emit('copy', id)
      }
    },
    edit(id) {
      if (this.exist(id)) {
        this.editor.input = this.get(id)
      }
    },
    update(value) {
      if (value) {
        this.$emit('update', value)
      }
    },
    remove(id) {
      if (this.exist(id)) {
        this.$emit('remove', id)
      }
    }
  },
}

</script>

<style lang="css" scoped>

.import-list {
  display : grid;
  gap     : var(--size-sm);
}

.list {
  display : grid;
  gap     : var(--size-xs);
}

</style>


// WEBPACK FOOTER //
// src/features/nonsc/pages/project-import/NonScImportList.vue